export default {"src":"/_next/static/media/checkbox-selected.5b76aa9a.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};